import { VideoProject } from "@/services/bedrock";

export interface EditorDraftSnapshot {
  message: string;
  hashtags: string;
  isAutoPost: boolean;
  preferredPostDate: string;
  allowShortLink: boolean;
  allowCompliance: boolean;
  allowPlayerHashtags: boolean;
  socialNetworkIds: string[];
  editedMedia: Array<{ id: number; uri: string; sortOrder: number; local: boolean }>;
}

export function captureEditorDraft(project: VideoProject, hashtags: string): EditorDraftSnapshot {
  return {
    message: project.post?.message ?? "",
    hashtags: hashtags.trim(),
    isAutoPost: !!project.isAutoPost,
    preferredPostDate: project.preferredPostDate ?? "",
    allowShortLink: !!project.allowShortLink,
    allowCompliance: !!project.allowCompliance,
    allowPlayerHashtags: !!project.allowPlayerHashtags,
    socialNetworkIds: (project.post?.postSocialNetworks ?? [])
      .map(sn => sn.socialNetworkId)
      .slice()
      .sort(),
    editedMedia: (project.editedMedia ?? []).map(media => ({
      id: media.id,
      uri: media.uri,
      sortOrder: media.sortOrder,
      local: !!media.imageFile,
    })),
  };
}

export function hasEditorDraftChanges(saved: EditorDraftSnapshot | null, current: EditorDraftSnapshot): boolean {
  if (!saved) return false;
  return JSON.stringify(saved) !== JSON.stringify(current);
}
